import { useMutation } from '@tanstack/react-query';

export function useCreateUserPasswordMutation() {
  return useMutation({
    mutationFn: async ({ userParams }) => {
      const response = await axios.post('/users/password', {
        user: userParams,
      });

      return response.data;
    },
  });
}
